<section id="/guide/email-collection-refuse">
  <h3 class="guide__heading heading heading_level_3">이메일주소 무단수집거부</h3>

  <h4 class="guide__heading heading heading_level_4">제1장 총칙</h4>

  <p class="guide__text text">
    본 커피멘토 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사처벌됨을 유념하시기
    바랍니다.<br/>
    <br/>
    이메일을 기술적 장치를 사용하여 무단으로 수집, 판매 및 유통하거나 이를 이용한 자는 [정보통신망 이용촉진 및 정보보호 등에 관한 법률] 제50조의 2규정에 의하여 1천만원 이하의 벌금형에
    처해집니다.<br/>
  </p>

  <h5 class="guide__heading heading heading_level_5">정보통신망법 제50조의2 (전자우편주소의 무단 수집행위 등 금지)</h5>
  <ol class="guide__text text">
    <li>누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로 전자우편 주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.</li>
    <li>누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매 및 유통하여서는 아니된다.</li>
    <li>누구든지 제1항 및 제2항의 규정에 의하여 수집, 판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보전송에 이용하여서는 아니된다.</li>
  </ol>
</section>
